import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

import { FormBuilderService, FormData, FormField, FormProviderService, PreventDoubleSubmission } from '@fry/lib/forms';
import { User, UsersStore } from '@fry/lib/users';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { UserFieldsStore } from '@fry/lib/user-fields';
import { RolesStore } from '@fry/lib/roles';


@Injectable()
export class UserAddForm {

    private formData: FormData;

    constructor(
        private provider: FormProviderService,
        private users: UsersStore,
        private userFields: UserFieldsStore,
        private roles: RolesStore,
        private builder: FormBuilderService,
    ) { }

    private options = { submitTitle: $localize `Create` };

    _fields = [
        { id: 'firstName', title: $localize `First name`, initial: '',
          widget: { type: 'string', autocomplete: 'given-name' },
          validators: [Validators.required] },
        { id: 'lastName', title: $localize `Last name`, initial: '',
          widget: { type: 'string', autocomplete: 'family-name' },
          validators: [Validators.required] },
        { id: 'email', title: $localize `Primary email`, initial: '',
          widget: { type: 'email', autocomplete: 'email' },
          validators: [Validators.required] }
    ];

    private getUserFields() {
      return this.userFields.defaultForm().pipe(
        switchMap(form => this.builder.buildForm(form, {})),
      );
    }

    private getRoles() {
      return this.roles.all().pipe(
        map(roles => {
          const opts = roles.map(role => {
            return { id: role.doc._id, name: role.doc.title };
          });
          return [{
            id: 'roles', title: $localize `Roles`, initial: '',
            options: {
                categories: opts,
            },
            widget: { type: 'multiSelect', autocomplete: '' },
            validators: [Validators.required],
          }];
        }));
    }

    getFields(): Observable<FormField[]> {
      return forkJoin([
        of(this._fields),
        this.getUserFields(),
        this.getRoles(),
      ]).pipe(
        map(res => [].concat(...res))
      );
      // return this.userFields.defaultForm().pipe(
      //   switchMap(form => this.builder.buildForm(form, {})),
      //   map(fields => [...this._fields, ...fields]),
      // );
    }

    init(user: User): Observable<FormData> {
      return this.getFields().pipe(
        switchMap(fields => this.provider.getFormDataWith(fields, user.doc, this.options)),
        tap(formData => this.formData = formData)
      );
    }

    @PreventDoubleSubmission()
    submit(user: User): Observable<User> {
        if (this.formData.invalid) {
            return throwError($localize `Please review the form`);
        }

        const value = this.formData.getValue();
        user.doc = value;
        return this.users.createLegacy(user);
    }

    get pristine() {
        if (!this.formData) {
            return true;
        }
        return this.formData.pristine;
    }


}
